import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";
import { TIngredientCategoryPayload } from "../../sdk/utils/api/ingredients";

export const useUpdateIngredientCategory = (
    invalidQueryKeys: string | (string | number)[],
): UseMutationResult<types.IIngredientCategory, unknown, { categoryId: string; body: TIngredientCategoryPayload }> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<types.IIngredientCategory, unknown, { categoryId: string; body: TIngredientCategoryPayload }>({
        mutationFn: async (parameters: { categoryId: string; body: TIngredientCategoryPayload }) => {
            if (!auth.token) {
                throw new Error("Cannot save without authorization token.");
            }
            return await api.Ingredients.updateCategory(parameters.categoryId, parameters.body, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
